// src/api/axiosInstance.js

import axios from "axios";
import { clearAuthData } from "../utils/auth";
import { BASE_DEV_URL, BASE_URL } from "../env";


const axiosInstance = axios.create({
  baseURL: process.env.NODE_ENV === "development" ? BASE_DEV_URL : BASE_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
  timeout: 15000,
});

// Optional: request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    const isLoginEndpoint =
      config.url?.includes("/user/userLogin") ||
      config.url?.includes("/user/autoDemoUserLogin") ||
      config.url?.includes("/account/v2/login") ||
      config.url?.includes("/user/registerShoutpe") ||
      config.url?.includes("/whatsapp/send-code") ||
      config.url?.includes("/whatsapp/verify") ||
      config.url?.includes("/user/checkUserNameOpen") ||
      config.url?.includes("/account/v2/users/phones");

    // Only add Bearer token if it's not a login endpoint and no custom Authorization header is set
    // Check both lowercase and uppercase since axios normalizes headers
    const hasAuthHeader = config.headers.Authorization || config.headers.authorization;
    if (!isLoginEndpoint && !hasAuthHeader) {
      // Prefer requested localStorage key (adminAccessToken), fallback to sessionStorage.authState
      try {
        const token = localStorage.getItem("authToken");
        if (token) {
          config.headers.Authorization = `Bearer ${token}`;
          return config;
        }
      } catch {
        // ignore
      }

      // 6wicket-compatible: token stored inside sessionStorage.authState
      try {
        const authState = sessionStorage.getItem("authState");
        if (authState) {
          const parsed = JSON.parse(authState);
          if (parsed?.token) {
            config.headers.Authorization = `Bearer ${parsed.token}`;
          }
        }
      } catch {
        // ignore
      }
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Optional: response interceptor
axiosInstance.interceptors.response.use(
  (response) => {
    const isPhoneExistsCheck =
      response.config?.url?.includes("/phones/") &&
      response.config?.url?.includes("exists");
    if (response?.data?.logout && !isPhoneExistsCheck) {
      clearAuthData();

      // Dispatch Redux logout without importing store at module load (avoids circular deps with authSlice).
      import("../store").then(({ store }) =>
        import("../store/slices/authSlice").then(({ logout }) => {
          store.dispatch(logout());
        }),
      );
    }
    return response.data;
  },
  (error) => Promise.reject(error),
);

export default axiosInstance;
